<form [formGroup]="form">
  <mat-form-field appearance="outline">
    @if (!hideLabel) {
      <mat-label>
        @if (!autoTranslate) {
          <span>{{labelName}}</span>
        }
        @if (autoTranslate) {
          <mwp-text-translate [text]="labelName" [jsonKey]="labelName" />
        }
      </mat-label>
    }
    <input matInput mwpMatInputMask [mwpMask]="'date'" type="datetime" [formControlName]="nameForControl" [min]="datePickerMin" [max]="datePickerMax" [matDatepicker]="datePicker" (dateInput)="onSelectionChanged($event)">
    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker></mat-datepicker>
  </mat-form-field>
</form>